import Action from "./comps/Action";
import Header from "./comps/Header";
import Text from "components/Table2/CellComps/Text";
import PriceComp from "components/Table2/CellComps/Price";
import { useDispatch, useSelector } from "react-redux";
import Number from "components/Table2/CellComps/Number";
import Box from "./comps/Box";
import { SetStateAction, useEffect, useState } from "react";
// import { apiGetAccounting } from "../../../api/accountingApi";
// import ExcelIcon from "assets/icons/ExcelIcon";
// import PdfIcon from "assets/icons/PdfIcon";
import { useNavigate } from "react-router-dom";
import { addOpenDrawer, setConfirm } from "../../../store/actions/appAction";
import EditImg from "assets/images/Edit.svg";
import DeleteImg from "assets/images/Delete.svg";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import DrawerHistory from "./comps/DrawerHistory";
import {
  apiCreateNotifications,
  apiDeleteNotifications,
  apiEditNotifications,
  apiGetItemNotifications,
} from "api/notificationApi";
import { apiGetHistory, apiGetItemNote } from "api/noteApi";
import { formatPrice } from "helpers";
import UserIcon from "assets/icons/invoice/UserIcon";
import { ArrowBackIos } from "@mui/icons-material";
import PriceFormat from "components/CloseFiscalYear/PriceFormat";
import { apiDeleteInstallments } from "../../../api/installmentApi";
import { getLastSyncDifference } from "components/simple/NotificationBox";
import getCurrency from "helpers/currencyHelper";

const initialTable: TableProps = {
  headers: [
    { label: "کالا" },
    { label: "تعداد" },
    { label: "مبلغ واحد" },
    { label: "تخفیف" },
    { label: "مالیات" },
    { label: "مبلغ کل" },
  ],
  cols: [
    { Comp: Text, key: "label" },
    { Comp: Number, key: "quantity" },
    { Comp: PriceComp, key: "price" },
    { Comp: Number, key: "discount" },
    { Comp: Number, key: "tax" },
    { Comp: PriceComp, key: "totalPrice" },
  ],
  headerColor: "#fff",
  rows: [],
  withoutMenu: true,
};

// const FactorContainer = styled("div")({
//   position: "fixed",
//   display: "none",
// });

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function InstallmentDrawer() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { drawerProps, anchor } = useSelector((state: any) => state).appReducer;
  const token = useSelector((state: any) => state).businessReducer.business?.token;

  const [installment, setInstallment] = useState(drawerProps?.installment);
  const [table, setTable] = useState(initialTable);
  const [notificationsList, setNotificationList] = useState([]);
  const [noteList, setNoteList] = useState([]);
  const [History, setHistory] = useState([]);
  // // tabs state
  const [value, setValue] = useState(0);
  const currency = getCurrency();
  // tab function
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  // ---tabFunction

  // // modal state
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  // // ===modal state

  useEffect(() => {
    if (installment) {
      // dispatch(
      //   apiGetFactor(factor.type_id ?? factor.id, factor.type, token, (factorObject: any) => {
      //     const newFactor = { ...factor, ...factorObject };
      //     renderTable(newFactor);
      //     setFactor(newFactor);
      //   })
      // );

      dispatch(
        // @ts-ignore
        apiGetItemNotifications(
          token,
          installment.type_id ?? installment.id,
          "Installment",
          (value: SetStateAction<never[]>) => {
            setNotificationList(value);
          }
        )
      );
      initialNote();
    }
  }, []);

  const initialNote = () => {
    dispatch(
      // @ts-ignore
      apiGetItemNote(
        token,
        installment.type_id ?? installment.id,
        "Installment",
        (value: SetStateAction<never[]>) => {
          setNoteList(value);
        }
      )
    );
    dispatch(
      // @ts-ignore
      apiGetHistory(
        token,
        installment.type_id ?? installment.id,
        "Installment",
        (value: SetStateAction<never[]>) => {
          setHistory(value);
        }
      )
    );
  };

  // if (!factor) return <></>;

  // const renderTable = (factor: any) => {
  //   const rows: any = [];

  //   factor.Factor_Items.map((item: any) => {
  //     rows.push({
  //       label: item?.Product?.title,
  //       quantity: item?.quantity,
  //       price: item?.price,
  //       discount: item?.discount,
  //       tax: item?.tax,
  //       totalPrice: item?.finalPrice,
  //     });
  //   });

  //   setTable({
  //     ...initialTable,
  //     rows,
  //   });
  // };

  // const details = [];
  // // factor.date && details.push(`تاریخ ثبت سیستم:   ${factor.date}`);
  // factor.date && details.push(`تاریخ صدور: ${factor.date}`);
  // factor.dueDate && details.push(`تاریخ سررسید: ${factor.dueDate}`);

  const closeDrawer = () => dispatch(addOpenDrawer(false, undefined, anchor));
  const editFactor = () => {
    closeDrawer();
    navigate(`/installments/${installment.type_id ?? installment.id}`);
  };

  const deleteFactor = () => {
    closeDrawer();
    dispatch(
      // @ts-ignore
      setConfirm("حذف اقساط", () =>
        dispatch(
          // @ts-ignore
          apiDeleteInstallments([installment.type_id ?? installment.id], token)
        )
      )
    );
  };

  const actions = {
    icons: [
      // { Icon: PrinterIcon, onClick: printFactor },
      // {Icon: ExcelIcon, onClick: excelExport},
      // {Icon: PdfIcon, onClick: printPdf}
    ],
    menu: [
      {
        label: "ویرایش",
        icon: <img src={EditImg} alt="" />,
        onClick: editFactor,
        show: true,
      },
      {
        Label: <span style={{ color: "#F42222", fontSize: "12px", fontWeight: 700 }}>حذف</span>,
        icon: <img src={DeleteImg} alt="" />,
        onClick: deleteFactor,
        show: true,
      },
    ],
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const submitNotification = (value: any) => {
    dispatch(
      // @ts-ignore
      apiCreateNotifications(
        token,
        installment.type_id ?? installment.id,
        "Installment",
        value?.title,
        value?.description,
        value.fireDate,
        () => {
          dispatch(
            // @ts-ignore
            apiGetItemNotifications(
              token,
              installment.type_id ?? installment.id,
              "Installment",
              (value: SetStateAction<never[]>) => {
                setNotificationList(value);
              }
            )
          );
          handleCloseModal();
        }
      )
    );
  };

  const handleDeleteNotification = (id: any) => {
    dispatch(
      // @ts-ignore
      apiDeleteNotifications(token, id, () => {
        dispatch(
          // @ts-ignore
          apiGetItemNotifications(
            token,
            installment.type_id ?? installment.id,
            "Installment",
            (value: SetStateAction<never[]>) => {
              setNotificationList(value);
            }
          )
        );
      })
    );
  };
  const handelChangeActive = (value: any) => {
    dispatch(
      // @ts-ignore
      apiEditNotifications(token, value?.id, value.active, () => {
        dispatch(
          // @ts-ignore
          apiGetItemNotifications(
            token,
            installment.type_id ?? installment.id,
            "Installment",
            (value: SetStateAction<never[]>) => {
              setNotificationList(value);
            }
          )
        );
      })
    );
  };

  //============================ JSX ===============================
  if (!installment) return <></>;

  return (
    <div style={{ backgroundColor: "#FCFEFF", height: "100vh", width: "680px" }}>
      <Header
        hasInstallment
        heading={installment?.Factor?.title}
        id={`${installment?.Factor?.accountingCode}`}
      />
      <Action
        reminderData={notificationsList}
        actions={actions}
        side={
          <div className="flex flex-col w-full item-start">
            {/* <div className="flex flex-row item-center">
              <span className="text-sm font-medium font-IRANSans text-dark-6">تاریخ پرداخت بعدی : </span>
              <span className="mr-1 text-sm font-medium font-IRANSans text-dark-6"> 1401/12/28 </span>
            </div>
            <div className="flex flex-row item-center">
              <div className="flex flex-row mt-1 item-center">
                <span className="text-xs font-medium font-IRANSans text-dark-9">تاریخ ثبت : </span>
                <span className="mr-1 text-xs font-medium font-IRANSans text-dark-9"> 1401/12/28 </span>
              </div>
              <span className="mx-1 text-dark-9">|</span>
              <div className="flex flex-row mt-1 item-center">
                <span className="text-xs font-medium font-IRANSans text-dark-9">تاریخ سر رسید اقساط : </span>
                <span className="mr-1 text-xs font-medium font-IRANSans text-dark-9"> 1401/12/28 </span>
              </div>
            </div> */}
          </div>
        }
        withReminder
        fireDate={""}
        submitNotification={(value) => {
          submitNotification(value);
        }}
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        handleOpenModal={handleOpenModal}
        deleteItem={(id) => handleDeleteNotification(id)}
        updateNotification={(val) => handelChangeActive(val)}
      />

      <div style={{ padding: "16px 32px" }}>
        {/* <div style={{ display: "flex", gap: 16 }}>
          <Price price={installment.Factor.totalPrice} currency={installment.Factor.Currency} />
          <Status title={installment.factor.status} status={installment.Factor.status === "تایید شده" ? "success" : "error"} />
        </div>
        <Details details={details} /> */}

        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="خلاصه" {...a11yProps(0)} />
          <Tab label="تاریخچه" {...a11yProps(1)} />
        </Tabs>

        <TabPanel value={value} index={0}>
          {/* <FactorDetail factor={factor} /> */}
          {/* <div style={{ height: 24 }} /> */}
          <div
            style={{
              whiteSpace: "nowrap",
              // overflow: "auto",
              position: "relative",
            }}
          >
            {/* summery section */}

            <div className="flex flex-row w-full item-center">
              <div className="flex flex-col ">
                <span className="text-[#A6AAB0] text-sm ">#</span>
                <span className="mt-3 text-sm text-[#393F47]">{`${installment?.Factor?.accountingCode}`}</span>
              </div>
              <div className="flex flex-col mr-3 ">
                <span className="text-[#A6AAB0] text-sm ">عنوان فاکتور</span>
                <span className="mt-3 text-sm text-[#393F47]">{`${installment?.Factor?.title}`}</span>
              </div>
              <div className="flex flex-col items-end flex-1 w-full mr-3 ">
                <div className="flex flex-col">
                  <span className="text-[#A6AAB0] text-sm ">مشتری</span>
                  <div
                    onClick={() => {
                      navigate(`/reports/personalAccountCard?personId=${installment?.Factor?.Person?.id}`);
                      dispatch(addOpenDrawer(false));
                    }}
                    className="flex flex-row items-center mt-3 cursor-pointer"
                  >
                    <UserIcon />
                    <span className="mr-1 text-sm ]">{`${installment?.Person}`}</span>
                    <ArrowBackIos sx={{ width: "16px", height: "16px" }} />
                  </div>
                </div>
              </div>
            </div>

            <div className="flex w-full flex-row border border-[#CAD1DE] rounded-md mt-4">
              <div className="flex flex-col items-center justify-center flex-1 w-full py-3 ">
                <span className="text-xs text-[#8D8E8F] ">باقی مانده</span>
                <span className="mt-3">
                  {PriceFormat({
                    value: installment.totalPaid - installment?.totalPrice,
                    currency: currency.defCur.en_title,
                  })}
                </span>
              </div>
              <div className="flex flex-1 w-full items-center justify-center flex-col py-3 border-l-[1px] border-r-[1px] border-[#CAD1DE]  ">
                <span className="text-xs text-[#8D8E8F] ">مبلغ کل</span>
                <span className="mt-3">
                  {PriceFormat({ value: installment?.totalPaid, currency: currency.defCur.en_title })}
                </span>
              </div>
              <div className="flex flex-col items-center justify-center flex-1 w-full py-3 ">
                <span className="text-xs text-[#8D8E8F] ">پرداخت شده</span>
                <span className="mt-3">
                  {PriceFormat({ value: installment?.totalPrice, currency: currency.defCur.en_title })}
                </span>
              </div>
            </div>

            <div className="flex flex-row items-center w-full mt-3 mb-8 ">
              <div className="flex flex-row items-center">
                <span className="ml-2 text-xs">سود</span>
                <span className="text-[#666666] text-xs">
                  {formatPrice(installment.profit)} {currency.defCur.en_title}
                </span>
              </div>
              <div className="flex flex-row items-center mr-4">
                <span className="ml-2 text-xs ">فاصله اقساط</span>
                <span className="text-[#666666] text-xs">{installment.interval} روز</span>
              </div>
            </div>

            {installment?.installments?.map((item: any, index: any) => (
              <div
                key={index}
                className="flex flex-row items-center border border-[#DDE4F0] w-full p-4 rounded-md mb-4"
              >
                <div className="relative ">
                  <IconCalculator />
                  <span className="absolute -top-2 -right-2 text-[#ABBACC] ">{index + 1}</span>
                </div>
                <div className="flex flex-col mr-3 ">
                  <div className="flex flex-row items-center">
                    <span className="ml-2 text-[#747575]">قسط: </span>
                    {PriceFormat({ value: item.price, currency: currency.defCur.en_title })}
                  </div>
                  {item?.isExpired ? (
                    <div className="flex flex-row items-center mt-3">
                      <span className="text-[#424242] bg-[#FFEAF0] py-1 px-2 rounded-md">
                        {getLastSyncDifference(item.date, false)}
                      </span>
                      {/*<span className="text-[#CB0B0B] mr-2">۲۳ روز گذشته</span>*/}
                    </div>
                  ) : (
                    <span className="text-[#747575] mt-3">{getLastSyncDifference(item.date, false)}</span>
                  )}
                </div>
                {/* <div className="flex justify-end flex-1 w-full">
                  {item?.paymentDate ? (
                    <div className="flex flex-row items-center bg-[#CEF0D1] py-2 px-3 rounded-full">
                      <Check />
                      <span className="text-[#24AF22] text-xs mr-2">۱۴۰۱/۱۲/۲۸</span>
                    </div>
                  ) : (
                    <div className="flex flex-row items-center px-3 py-2 cursor-pointer">
                      <PlusIcon scale={0.5} />
                      <span className="mr-2 text-xs text-blue-1">پرداخت قسط</span>
                    </div>
                  )}
                </div> */}
              </div>
            ))}

            {/* summery section */}
          </div>
          {/* <div style={{ height: 24 }} /> */}
          {/* <FactorSum factor={factor} /> */}
        </TabPanel>
        <TabPanel value={value} index={1}>
          {/* history section */}
          <DrawerHistory
            title={"فاکتور"}
            history={History}
            noteList={noteList}
            token={token}
            detail_type="Installment"
            id={installment.type_id ?? installment.id}
            refresh={() => {
              initialNote();
            }}
          />
        </TabPanel>
      </div>
    </div>
  );
}

const IconCalculator = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M25.995 9.394v21.492c0 .492-.4.892-.892.892H8.892A.892.892 0 0 1 8 30.886V9.394c0-.493.4-.892.892-.892h16.211c.493 0 .892.4.892.892Z"
      fill="#DEDDFF"
    />
    <path
      d="M17.484 22.344a.37.37 0 0 0-.37-.37h-5.42a.37.37 0 0 0 0 .74h5.42a.37.37 0 0 0 .37-.37Z"
      fill="#46CC6B"
    />
    <path
      d="M17.484 20.305a.37.37 0 0 0-.37-.37h-5.42a.37.37 0 0 0 0 .74h5.42a.37.37 0 0 0 .37-.37Z"
      fill="#65B9FF"
    />
    <path
      d="M14.12 20.674h-2.426a.37.37 0 0 1-.37-.37.37.37 0 0 1 .37-.37h2.425c-.2 0-.37.165-.37.37s.17.37.37.37Z"
      fill="#3E7FFF"
    />
    <path
      d="M20.814 22.344a.37.37 0 0 0-.37-.37h-1.855a.37.37 0 0 0 0 .74h1.854a.37.37 0 0 0 .37-.37Z"
      fill="#E83D62"
    />
    <path
      d="M13.252 9.93v6.57a.22.22 0 0 1-.22.22h-1.628a.22.22 0 0 1-.22-.22V9.93a.22.22 0 0 1 .22-.219h1.628a.22.22 0 0 1 .22.22Z"
      fill="#46CC6B"
    />
    <path
      d="M11.893 16.72h-.488a.22.22 0 0 1-.22-.22V9.93a.22.22 0 0 1 .22-.22h.488a.22.22 0 0 0-.218.22V16.5c0 .123.098.22.218.22Z"
      fill="#179C5F"
    />
    <path
      d="M16.439 12.905V16.5a.22.22 0 0 1-.22.22h-1.628a.22.22 0 0 1-.22-.22v-3.595a.22.22 0 0 1 .22-.22h1.628a.22.22 0 0 1 .22.22Z"
      fill="#E83D62"
    />
    <path
      d="M15.08 16.718h-.488a.22.22 0 0 1-.22-.22v-3.593c0-.12.098-.22.22-.22h.488c-.12 0-.22.1-.22.22v3.593c0 .122.1.22.22.22Z"
      fill="#CE2955"
    />
    <path
      d="M19.624 11.789V16.5a.22.22 0 0 1-.22.22h-1.627a.22.22 0 0 1-.22-.22V11.79a.22.22 0 0 1 .22-.22h1.627a.22.22 0 0 1 .22.22Z"
      fill="#65B9FF"
    />
    <path
      d="M18.266 16.72h-.49a.22.22 0 0 1-.219-.221v-4.711c0-.121.098-.22.219-.22h.49a.22.22 0 0 0-.22.22v4.71c0 .123.097.221.22.221Z"
      fill="#3E7FFF"
    />
    <path
      d="M22.81 14.014V16.5a.22.22 0 0 1-.22.22h-1.628a.22.22 0 0 1-.22-.22v-2.486a.22.22 0 0 1 .22-.22h1.628a.22.22 0 0 1 .22.22Z"
      fill="#FCB73E"
    />
    <path
      d="M21.451 16.72h-.488a.22.22 0 0 1-.22-.221v-2.484a.22.22 0 0 1 .22-.22h.488a.22.22 0 0 0-.218.22v2.484c0 .122.098.22.218.22Z"
      fill="#E87F21"
    />
    <path
      d="M9.806 31.775h-.917A.886.886 0 0 1 8 30.888V9.393c0-.49.397-.893.888-.893h.917a.896.896 0 0 0-.893.893v21.495c0 .49.402.887.893.887Z"
      fill="#C6C6F7"
    />
    <path
      d="M32.075 18.297v12.595c0 .665-.54 1.204-1.205 1.204h-9.166c-.665 0-1.204-.539-1.204-1.204V18.297c0-.665.54-1.204 1.204-1.204h9.166c.665 0 1.205.54 1.205 1.204Z"
      fill="#5B5E8B"
    />
    <path
      d="M23.428 32.096h-1.724a1.204 1.204 0 0 1-1.204-1.204V18.297c0-.665.54-1.204 1.204-1.204h1.724c-.667 0-1.204.54-1.204 1.204v12.595c0 .666.537 1.204 1.204 1.204Z"
      fill="#312E4B"
    />
    <path
      d="M30.781 18.879v2.76a.315.315 0 0 1-.315.314h-8.358a.315.315 0 0 1-.315-.315V18.88c0-.174.141-.315.315-.315h8.358c.174 0 .315.14.315.315Z"
      fill="#65B9FF"
    />
    <path
      d="M22.778 21.953h-.67a.314.314 0 0 1-.314-.314v-2.76c0-.175.14-.315.315-.315h.669a.314.314 0 0 0-.314.314v2.76c0 .175.14.315.314.315Z"
      fill="#3E7FFF"
    />
    <path
      d="M22.903 25.066a1.11 1.11 0 1 0 0-2.218 1.11 1.11 0 0 0 0 2.218ZM26.288 25.066a1.11 1.11 0 1 0 0-2.218 1.11 1.11 0 0 0 0 2.218ZM29.672 25.066a1.11 1.11 0 1 0 0-2.219 1.11 1.11 0 0 0 0 2.22ZM29.672 28.178a1.11 1.11 0 1 0 0-2.22 1.11 1.11 0 0 0 0 2.22ZM26.288 28.178a1.11 1.11 0 1 0 0-2.22 1.11 1.11 0 0 0 0 2.22ZM22.903 28.178a1.11 1.11 0 1 0 0-2.22 1.11 1.11 0 0 0 0 2.22ZM29.672 31.29a1.11 1.11 0 1 0 0-2.219 1.11 1.11 0 0 0 0 2.22Z"
      fill="#DEDDFF"
    />
    <path
      d="M30.69 30.615a1.11 1.11 0 1 1-1.452-1.457c-.39.907.525 1.847 1.453 1.457ZM30.691 27.505a1.11 1.11 0 1 1-1.453-1.457c-.389.905.523 1.848 1.453 1.457ZM27.307 27.505a1.11 1.11 0 1 1-1.453-1.457c-.389.905.523 1.848 1.453 1.457ZM23.923 27.505a1.11 1.11 0 0 1-2.13-.436c0-.459.28-.852.677-1.021-.39.905.522 1.848 1.453 1.457ZM30.69 24.392a1.11 1.11 0 1 1-1.452-1.457c-.39.905.523 1.848 1.453 1.457ZM27.307 24.392a1.11 1.11 0 1 1-1.453-1.457c-.389.905.523 1.848 1.453 1.457ZM23.923 24.392a1.11 1.11 0 0 1-2.13-.436c0-.459.28-.852.677-1.02-.39.904.522 1.847 1.453 1.456Z"
      fill="#C6C6F7"
    />
    <path
      d="M27.397 30.18a1.11 1.11 0 0 1-1.07 1.107v.001h-3.423a1.109 1.109 0 1 1 0-2.218h3.423v.001c.594.02 1.07.509 1.07 1.108Z"
      fill="#E83D62"
    />
    <path d="M23.696 31.288h-.792a1.109 1.109 0 1 1 0-2.218h.792a1.108 1.108 0 1 0 0 2.218Z" fill="#CE2955" />
    <rect x=".5" y=".5" width="39" height="39" rx="19.5" stroke="#CAD1DE" />
  </svg>
);

const Check = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.375 9 7.5 13.5l6.565-7.825"
      stroke="#24AF22"
      strokeWidth="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
